<template>
  <div class="app-container">
    <Container
      :title="t('route.userInfo')"
    >
      <template #main>
        <el-row>
          <el-col :span="12">
            <CenterForm
              :formModel="userFormModel"
              :formStruct="userFormStruct"
              :labelWidth="'200px'"
              :readonly="true"
            />
          </el-col>
        </el-row>
      </template>
    </Container>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, toRefs, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { createModel } from '@/utils/component'
import CenterForm from '@/components/form/common/CenterForm.vue'
import { useStore } from '@/store'
import Container from '@/components/form/container/Container.vue'
import { getUserInfoById } from '@/apis/user'

export default defineComponent({
  components: {
    Container,
    CenterForm
  },
  setup() {
    const { t } = useI18n()
    const store = useStore()
    const struct = [
      { prop: 'userAccount', label: t('userInfo.userAccount'), component: 'el-input', type: 'text', model: '' },
      { prop: 'userName', label: t('userInfo.userName'), component: 'el-input', type: 'text', model: '' },
      { prop: 'mailAddress', label: t('userInfo.mailAddress'), component: 'el-input', type: 'text', model: '' },
      { prop: 'userRoleNames', label: t('userInfo.userRoleNames'), component: 'el-input', type: 'text', model: '' },
      { prop: 'department', label: t('userInfo.department'), component: 'el-input', type: 'text', model: '' }
    ]
    const dataMap = reactive({
      userFormStruct: struct,
      userFormModel: createModel(struct) as any,
      async initUser() {
        const userInfo = store.state.user.info
        if (userInfo) {
          const data = await getUserInfoById(userInfo?.userId)
          if (data && data.data) {
            dataMap.userFormModel.userAccount = data.data.userAccount
            dataMap.userFormModel.userName = data.data.userName
            dataMap.userFormModel.mailAddress = data.data.mailAddress
            dataMap.userFormModel.userRoleNames = data.data.userRoleNames
            dataMap.userFormModel.department = data.data.department
          }
        }
      }
    })
    onMounted(() => {
      dataMap.initUser()
    })
    return {
      t,
      ...toRefs(dataMap)
    }
  }
})
</script>

<style scoped lang="scss">

</style>
